<template>
  <video-library
    v-if="showVideoUpload"
    :pre-selected-id="preSelectedId"
    :showVideoUpload="showVideoUpload"
    @close="handleClose"
    @update-instance="
      (videoInstance, videoInfo, successCB) => handleVideoSelection(videoInstance, videoInfo, successCB)
    "
    @update-instance-video-upload="videoInstance => handleVideoUpload(videoInstance)"
    @update-instance-image-upload="videoInstance => handleImageUpload(videoInstance)"
    @active-image-drawer="handleActiveImageDrawer"
    @video-upload-failed="handleVideoUploadFailed"
    @uploaded-image="handleUploadedImage"
  />
</template>
<script>
import { defineComponent, getCurrentInstance, computed } from 'vue-demi';
import videoLibrary from '@/components/video-library/index.vue';
import adsCreative from '@/store/modules/ads_creative';
import { MaterialSource, MaterialType, videoStage } from '@/const/media';
import teaTracker from '@/tea-tracker';
import { TEA_EVENT } from '@/const/state/TeaNames';
const name = 'video-upload-data';
export default defineComponent({
  name,
  components: {
    videoLibrary,
  },
  props: {
    showVideoUpload: {
      type: Boolean,
      default: false,
    },
    preSelectedId: {
      type: String,
      default: '',
    },
  },
  setup(_, { emit }) {
    const { proxy: _this } = getCurrentInstance();
    const handleUploadedImage = imageInstance => {
      adsCreative.mutations.setMediaInfo(imageInstance, MaterialType.IMAGE);
    };
    const handleVideoUploadFailed = () => {
      _this.$toast(_this.$t('module_fastcreation_creative_upload_fail'));
      adsCreative.mutations.setVideoStage(videoStage.INIT);
    };
    const handleActiveImageDrawer = () => {
      teaTracker.trackEvent(TEA_EVENT.USER_CLICK_CREATE_VIDEO_FROM_IMAGE);
      adsCreative.mutations.resetMediaInfo();
    };
    const handleClose = () => {
      adsCreative.mutations.setClearLibraryVideoList([], 0);
      emit('close');
    };
    const handleVideoSelection = (videoInstance, videoInfo, successCB) => {
      adsCreative.mutations.setVideoStage(videoStage.FINISH);
      adsCreative.mutations.setCreatingVideoStatus(false);
      adsCreative.mutations.setActiveSource(MaterialSource.LIBRARY);
      adsCreative.mutations.setCreativeData(videoInfo);
      adsCreative.mutations.setMediaInfo(videoInstance, MaterialType.VIDEO);
      teaTracker.trackEvent(TEA_EVENT.USER_CHOOSE_A_VIDEO_FROM_LIBRARY);
      emit('update-instance', videoInstance, successCB);
    };

    const handleVideoUpload = instance => {
      adsCreative.mutations.setVideoStage(videoStage.UPLOADING);
      adsCreative.mutations.setCreatingVideoStatus(true);
      adsCreative.mutations.setActiveSource(MaterialSource.CAMERA_ROLL);
      adsCreative.mutations.setUsingTikTokAccountUnderOwner(false);
      adsCreative.mutations.setMediaInfo(instance, MaterialType.VIDEO);
      teaTracker.trackEvent(TEA_EVENT.USER_CLICK_CONTINUE_TO_UPLOAD_VIDEO);
    };
    const handleImageUpload = instance => {
      adsCreative.mutations.setCreatingVideoStatus(true);
      adsCreative.mutations.setVideoStage(videoStage.UPLOADING);
      adsCreative.mutations.setActiveSource(MaterialSource.CAMERA_ROLL);
      adsCreative.mutations.setUsingTikTokAccountUnderOwner(false);
      adsCreative.mutations.setVideoUploaded(true);
      instance.optimize();
      teaTracker.trackEvent(TEA_EVENT.USER_START_CREATE_VIDEO_BY_IMAGE);
    };
    return {
      handleClose,
      handleImageUpload,
      handleVideoUpload,
      handleVideoSelection,
      handleUploadedImage,
      handleVideoUploadFailed,
      handleActiveImageDrawer,
    };
  },
});
</script>
<style></style>
